import { MaskConfig } from './mask-config';

// ngx-mask documentation - https://www.npmjs.com/package/ngx-mask
export class MaskUtility {
  static getEntityIdMask(prefix: string): MaskConfig {
    if (prefix === null || prefix.length !== 2) {
      return null;
    }
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
    };
    return {
      prefix: `${prefix}-`,
      mask: '00-0000-000',
      specialCharacters: ['-'],
      dropSpecialCharacters: false,
      patterns: patterns,
    };
  }

  static getSSNMask(SSN: string): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
    };
    if (SSN.length > 5) {
      return {
        mask: '000-00-0000',
        specialCharacters: ['-'],
        dropSpecialCharacters: false,
        patterns: patterns,
      };
    }
  }

  static getFullSSNMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
    };
    return {
      mask: '000-00-0000',
      specialCharacters: ['-'],
      dropSpecialCharacters: false,
      patterns: patterns,
    };
  }

  static getFEINMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
    };
    return {
      mask: '00-0000000',
      specialCharacters: ['-'],
      dropSpecialCharacters: false,
      patterns: patterns,
    };
  }

  static getExternalFEINMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[^-]/,
      },
    };
    return {
      mask: '00-0000000',
      specialCharacters: ['-'],
      dropSpecialCharacters: false,
      patterns: patterns,
    };
  }

  static getTpaNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
    };
    return {
      mask: 'T000000',
      specialCharacters: ['T'],
      dropSpecialCharacters: false,
      patterns: patterns,
    };
  }

  static getInsurerNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
      X: {
        pattern: /[WB|wb]/,
      },
    };
    return {
      mask: 'X000000',
      specialCharacters: ['-'],
      dropSpecialCharacters: true,
      patterns: patterns,
    };
  }

  static getInsurerWNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
      X: {
        pattern: /[W|w]/,
      },
    };
    return {
      mask: 'X000000',
      specialCharacters: ['-'],
      dropSpecialCharacters: true,
      patterns: patterns,
    };
  }

  static getInsurerBNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /[0-9]/,
      },
      X: {
        pattern: /[B|b]/,
      },
    };
    return {
      mask: 'X000000',
      specialCharacters: ['-'],
      dropSpecialCharacters: true,
      patterns: patterns,
    };
  }

  static getPhoneCountryCodeMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
      9: {
        pattern: /\d/,
        optional: true,
      },
    };
    return {
      mask: '099',
      prefix: '+',
      specialCharacters: ['+'],
      dropSpecialCharacters: true,
      patterns,
    };
  }

  static getPhoneExtensionMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
      9: {
        pattern: /\d/,
        optional: true,
      },
    };
    return {
      mask: '099999999999',
      prefix: 'x ',
      specialCharacters: ['x', ' '],
      dropSpecialCharacters: true,
      patterns,
    };
  }

  static getUsPhoneNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
    };
    return {
      mask: '(000) 000-0000',
      specialCharacters: ['(', ')', '-', ' '],
      dropSpecialCharacters: true,
      patterns,
    };
  }

  static getNonUsPhoneNumberMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
      9: {
        pattern: /\d/,
        optional: true,
      },
    };
    return {
      mask: '0999999999',
      specialCharacters: ['(', ')', '-', ' '],
      dropSpecialCharacters: true,
      patterns,
    };
  }

  static getZipCodeMask(): MaskConfig {
    const patterns = {
      0: {
        pattern: /\d/,
      },
      9: {
        pattern: /\d/,
        optional: true,
      },
    };
    return {
      mask: '00000-9999',
      specialCharacters: ['-'],
      dropSpecialCharacters: true,
      patterns,
    };
  }
}
